import { displayName } from '../../../../App';
import NotificationsLayout from '../../../components/Layout/Notifications';
import Content from '../../../components/Pages/Notifications/Email';
import { ENotificationsContextProvider } from '../../../context/e-notifications';

function NotificationEmail() {
  document.title = `${displayName}: Notification Email`;

  return (
    <NotificationsLayout>
      <ENotificationsContextProvider>
        <Content />
      </ENotificationsContextProvider>
    </NotificationsLayout>
  );
}

export default NotificationEmail;
